import { h } from 'preact'

interface SwapButtonProps {
  isRotated: boolean
  onClick: () => void
}

const SwapButton = ({ isRotated, onClick }: SwapButtonProps) => {
  return (
    <button
      className="double-input-calculator__swap"
      type="button"
      aria-label="swap currencies"
      onClick={onClick}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1000 1000"
        className={`double-input-calculator__swap-svg${isRotated ? ' double-input-calculator__swap-svg--rotated' : ''}`}
        height="20"
        width="20"
        data-rotate-icon
        aria-hidden="true"
      >
        <path
          style={{ fill: '#0062ff' }}
          d="M10,684v122c0,11,9,21,20,21h633v163l327-245-327-245v163H30c-11,0-20,10-20,21ZM990,316v-122c0-11-9-21-20-21H337V10L10,255l327,245v-163h633c11,0,20-9,20-21Z"
        />
      </svg>
    </button>
  )
}

export default SwapButton
